const config = {
  API_SERVER_URL: process.env.REACT_APP_API_SERVER_URL,
};

export default {
  ...config,
};
